// extracted by mini-css-extract-plugin
export default {"imageIcon":"FloatingButton_imageIcon__tNzbk","shake":"FloatingButton_shake__CQujG"};